import { StackScreenProps } from '@react-navigation/stack';
import { AuthNavigatorParamsList } from '../navigators/AuthNavigator/AuthNavigator.types';
import { ForgotPasswordNewPassword } from '../components';
import { Screen } from '@betty/navigation';

export type ForgotPasswordNewPasswordScreenProps = StackScreenProps<
  AuthNavigatorParamsList,
  'ForgotPasswordNewPasswordScreen'
>;

function ForgotPasswordNewPasswordScreen({
  route,
}: ForgotPasswordNewPasswordScreenProps) {
  const { token, accountid } = route.params;

  return (
    <Screen paddingBottom="safe-area-inset-bottom">
      <ForgotPasswordNewPassword token={token} accountid={accountid} />
    </Screen>
  );
}
export default ForgotPasswordNewPasswordScreen;
